export const SET_LOGIN = 'SET_LOGIN';
export const SET_PROFILE = 'SET_PROFILE';
export const SET_AUTHENTICATING = 'SET_AUTHENTICATING';
export const SIGNOUT_SUCCESS = 'SIGNOUT_SUCCESS';
export const SET_ORGANIZATION = 'SET_ORGANIZATION';
export const SET_MEMBERS = 'SET_MEMBERS';
export const SET_ORGANIZATIONS = 'SET_ORGANIZATIONS';
export const UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION';
export const REMOVE_MEMBER = 'REMOVE_MEMBER';
